/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import React from 'react';

import DocumentTitle from '~/src/common/document-title';

export default class AdultSwimContacts extends React.Component {
    constructor(props) {
        super(props);

        return;
    }

    render() {
        return (
            <DocumentTitle message="static.page.title.adultswim-contacts">
                <div className="container padding-y-10 padding-x-20">
                    <div className="row">
                        <h1>Contact Us</h1>
                    </div>
                    <div className="row">
                        <table className="table cart-parent-table">
                            <thead>
                                <tr>
                                    <th scope="col" className="no-sort">NAME</th>
                                    <th scope="col" className="no-sort">EMAIL</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Samantha Sur</td>
                                    <td><a href="mailto:samantha.sur@warnermedia.com">samantha.sur@warnermedia.com</a></td>
                                </tr>
                                <tr>
                                    <td>Nicole Yavasile</td>
                                    <td><a href="mailto:nicole.yavasile@warnermedia.com">nicole.yavasile@warnermedia.com</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <h1>Technical Support</h1>
                    </div>
                    <div className="row">
                        <table className="table cart-parent-table">
                            <thead>
                                <tr>
                                    <th scope="col" className="no-sort">NAME</th>
                                    <th scope="col" className="no-sort">EMAIL</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Account Support</td>
                                    <td><a href="mailto:wbtvd@warnerbros.com">wbtvd@warnerbros.com</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </DocumentTitle>
        );
    }
}
